import React from "react";
//#region types
import { StyleEnums } from "models/enums";
import { IncomingInvoiceDueDateBannerProps } from "models/propTypes/incomingInvoicePropTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
import { DateConstants } from "utils/constants";
//#endregion
//#region components
import { Banner } from "components/common";
import { Grid } from "@mui/material";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const IncomingInvoiceDueDateBanner: React.FC<IncomingInvoiceDueDateBannerProps> = (props) => {
  if(props.hidden) return <></>;

  const getBannerContent = () => {
    switch (props.displayType) {
      case StyleEnums.DisplayType.Warning:
        return (
          <Grid item>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.SoonDueInDays, "", {
              numOfDays: `${props.dueIn}`,
            })}
          </Grid>
        );
      case StyleEnums.DisplayType.Danger:
        return (
          <Grid item>
            {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.IncomingInvoice.OverDueOn, "", {
              dueDate: LocalizationHelperInstance.getFormattedDate(props.dueDate, DateConstants.DateMonthLongConfig),
            })}
          </Grid>
        );
    }
  };
  return (
    <Banner
      title={LocalizationHelperInstance.getFormattedMessage(
        props.displayType === StyleEnums.DisplayType.Warning
          ? TranslationKeys.Common.SoonOverdue
          : TranslationKeys.Common.Overdue
      )}
      icon={IconDefinitionConstants.WBell}
      type={props.displayType}
    >
      <Grid container direction="column" spacing={2}>
        {getBannerContent()}
      </Grid>
    </Banner>
  );
};

export default IncomingInvoiceDueDateBanner;
